<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName"
        @sortChanged="event => emit('sortChanged', event)" @loadMore="emit('loadMore')">
         <template #col-report_date="{ row }">
                {{  renderDate(row.report_date)}}
        </template>
        <template #col-opening_balance="{ row }">
                {{  formatCurrency(row.balances[0].amount,row.balances[0].currency)}}
        </template>
        <template #col-closing_balance="{ row }">           
                {{  formatCurrency(row.balances[1].amount,row.balances[1].currency)}}
        </template>
        <template #col-available_balance="{ row }"> 
                {{  formatCurrency(row.balances[2].amount,row.balances[2].currency)}}
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { formatCurrency, renderDate} from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore', 'details'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'bic', label: 'bic', sortable: false },
    { key: 'transaction_reference', label: 'reference', sortable: false },
    { key: 'statement_reference', label: 'statement', sortable: false },
    { key: 'report_date', label: 'date', sortable: false },
    { key: 'opening_balance', label: 'opening_balance', sortable: false },
    { key: 'closing_balance', label: 'closing_balance', sortable: false },
    { key: 'available_balance', label: 'available_balance', sortable: false }
])

const actionButtons = ref([
    { text: 'details', icon: 'FileTextIcon', color: 'primary', permissions: ['IU HSBC REPORT'], onClick: row => emit('details', row) }
])

</script>

<style></style>
